import Layers from "slotworks/graphics/layers/layers";
import { AbstractSceneTransition } from "slotworks/graphics/layers/scene-transitions/abstract-scene-transition";
import Contract from "slotworks/utils/contracts/contract";
import sgWinRespinCelebrator from "../components/sg-win-respin-celebrator";

export default class FreespinsRetriggerTransition extends AbstractSceneTransition {

    constructor(layer: Layers) {
        super(layer);
    }

    public in(): Contract<void> {
        return sgWinRespinCelebrator.startFreespinRetrigger();
    }

    public out(): Contract<void> {
        return sgWinRespinCelebrator.endFreespinRetrigger();
    }
}
